/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */

/**
 * e.g. "unknown", "normal", "warning", "critical"
 */
export type AlertStatus = (typeof AlertStatus)[keyof typeof AlertStatus];

export const AlertStatus = {
  UNKNOWN: 'unknown',
  OK: 'ok',
  INWARNING: 'inWarning',
  INALERT: 'inAlert',
} as const;
